<script>
import { TABS } from './constants';

export default {
  name: 'CoLivingTabs',
  data() {
    return { tabs: TABS };
  },
};
</script>

<template>
  <nav
    class="flex gap-4 border-b border-slate-200 dark:border-slate-700 mb-6"
    data-testid="co-living-tabs"
  >
    <router-link
      v-for="tab in tabs"
      :key="tab.key"
      :to="{ name: tab.route, params: { accountId: $route.params.accountId } }"
      class="pb-2 text-sm font-medium border-b-2"
      :class="
        $route.name === tab.route
          ? 'border-woot-500 text-woot-600 dark:text-woot-400'
          : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100 hover:border-slate-300 dark:hover:border-slate-500 transition-colors'
      "
      :data-testid="`co-living-tab-${tab.key}`"
    >
      {{ $t(`CO_LIVING.TABS.${tab.key.toUpperCase()}`) }}
    </router-link>
  </nav>
</template>
